<script setup lang="ts">
import ModalShell from '~/components/property/access/modals/ModalShell.vue';
import CheckBullet from '~/components/property/access/modals/CheckBullet.vue';

// 100% Commission explainer (ID-118). Opened only by the agent's own tap on the chip or its "i" button.
const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { t } = useI18n();
const titleId = useId();
</script>

<template>
  <ModalShell
    accent="gold"
    :labelled-by="titleId"
    @close="emit('close')"
  >
    <h2
      :id="titleId"
      class="mb-4 pe-6 font-serif text-[24px] font-semibold leading-[1.15] tracking-[-0.015em] text-black-100"
    >
      {{ t('exclusives.modal.title') }}
    </h2>
    <ul class="mb-6 space-y-2">
      <CheckBullet accent="gold">{{ t('exclusives.modal.bulletOnlyInsiders') }}</CheckBullet>
      <CheckBullet accent="gold">{{ t('exclusives.modal.bulletKeepAll') }}</CheckBullet>
      <CheckBullet accent="gold">{{ t('exclusives.modal.bulletFastPay') }}</CheckBullet>
    </ul>
    <button
      type="button"
      class="inline-flex h-11 w-full items-center justify-center rounded-[10px] bg-black-100 px-5 text-[14px] font-bold text-white transition-colors hover:bg-black-90"
      @click="emit('close')"
    >
      {{ t('exclusives.modal.showProjects') }}
    </button>
  </ModalShell>
</template>
